import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";

const CheckBox: React.FC<{
  checked: boolean;
  indeterminate?: boolean;
  classNames?: string;
  onClick?: () => void;
  iconSize?: number;
  disabled?: boolean;
}> = ({ indeterminate, classNames, onClick, iconSize, checked, disabled }) => {
  const iconProps = iconSize ? { size: iconSize } : {};
  const isActive = checked || indeterminate;
  return (
    <button
      aria-label="Check Box"
      data-openreplay-label="misc_checkbox_click"
      id="btn-check-box"
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-1 size-4 flex items-center justify-center",
        "bg-background_white_overlay10 disabled:cursor-not-allowed",
        "md:not-actived:hover:bg-background_white_overlay20 disabled:bg-background_white_overlay20",
        "actived:bg-background_brand_overlay100",
        "md:actived:not-disabled:hover:[background-image:var(--bg-linear-gradient)]",
        "actived:disabled:bg-background_white_overlay20 group",
        classNames,
      )}
      style={{
        "--bg-linear-gradient":
          "linear-gradient(0deg,var(--edgen-background_white_overlay20)),linear-gradient(0deg,var(--edgen-background_brand_overlay100))",
      }}
      data-actived={isActive}
      disabled={disabled}
    >
      <Icon
        name="check-alt"
        className={cn(
          "!hidden text-content_inverse_primary group-actived:group-disabled:text-content_quaternary group-actived:!inline",
        )}
        {...iconProps}
        size={12}
      />
      {indeterminate && !checked && (
        <Icon
          name="minus"
          color={ospThemes.colors.content_inverse_primary}
          size={16}
          {...iconProps}
        />
      )}
    </button>
  );
};

export default CheckBox;
